import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const config = {
    apiKey: "AIzaSyAPRI2oubEx9ISh-ULWeilHYaDOpid9i3A",
    authDomain: "oracle-ood.firebaseapp.com",
    projectId: "oracle-ood",
    storageBucket: "oracle-ood.appspot.com",
    messagingSenderId: "787955197330",
    appId: "1:787955197330:web:7bb45926d7f703516f8d4b",
    measurementId: "G-W9NJT7JY78"
  };

firebase.initializeApp(config);

export const db = firebase.firestore();
